export const CreditTableHead = [
  "username",
  "email",
  "Amount",
  "Balance",
  "source",
  "Time",
  "Date",
];
